import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AucHomeComponent } from "@auction-ui/home/home.component";
import { MFActionCardsModule } from "@pattonair/material-framework";


@NgModule({
  declarations: [
    AucHomeComponent
  ],
  exports: [
    AucHomeComponent
  ],
  imports: [
    BrowserModule,
    MFActionCardsModule,
  ],
  providers: [
  ]
})
export class AucHomeModule { }